import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const EducationTraining = () => {
  return (
    <>
      <SEO 
        title="Education & Training Solutions - Abacies Logiciels"
        description="Enhance learning outcomes with AI-powered education platforms, learning management systems, student analytics, and digital transformation solutions for educational institutions and training organizations."
        keywords="education technology, learning management systems, EdTech solutions, student analytics, educational software, training platforms"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Education & Training
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Education & Training page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Education & Training. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default EducationTraining;
